import Marionette from 'backbone.marionette';
import memberContributorItemviewTmpl from '../templates/member_contributors_itemview.tpl';
export default Marionette.ItemView.extend({
  template: memberContributorItemviewTmpl,
  tagName: "tr"
});